import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  DELETE_USERS_REQUEST,
  DELETE_USERS_SUCCESS,
  DELETE_USERS_FAILED,
  RESEND_INVITE_REQUEST,
  RESEND_INVITE_SUCCESS,
  RESEND_INVITE_FAILED,
  ASSIGN_LABELS_REQUEST,
  ASSIGN_LABELS_SUCCESS,
  ASSIGN_LABELS_FAILED,
  SET_SELECTED_USER,
  TOGGLE_ALL_ROWS,
  ADD_USER_WITH_CSV_SUCCESS,
} from './actionTypes';

import { toggleSelected } from '../../../core/helpers/default';
import { POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS, POST_SEND_SMS_SUCCESS, POST_SMS_CAMPAIGN_SUCCESS } from '../SmsCampaigns/actionTypes';
import { GET_CHAT_MESSAGES_SUCCESS } from '../ChatComponent/actionTypes';

const initialState = {
  users: [],
  loading: false,
  error: null,
  meta: {
    search: '',
    page: 1,
    lastPage: 1,
    sort: null,
    order: null,
    perPage: 50,
  },
  has_outstanding: null,
  sms_campaign_id: null,
  has_unread_message: null,
  usersIds: [],
  forceFetch: false
};

const usersReducer = (state = initialState, {
  type, error, users, meta, deletedId, userId, selectAll,
}) => {
  switch (type) {
    case DELETE_USERS_REQUEST:
      return { ...state, loading: true };
    case DELETE_USERS_SUCCESS:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== deletedId),
        loading: false,
      };
    case DELETE_USERS_FAILED:
      return { ...state, loading: false, error };
    case GET_USERS_REQUEST:
      return { ...state, loading: true };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: users.map((el) => ({
          ...el,
          _selected: false,
        })),
        meta: {
          search: meta.search,
          page: meta.current_page,
          lastPage: meta.last_page,
          perPage: meta.per_page,
          order: meta.order,
          sort: meta.sort,
        },
        filter_by_labels: meta.filter_by_labels,
        has_outstanding: meta.has_outstanding,
        has_unread_message: meta.has_unread_message,
        sms_campaign_id: meta.sms_campaign_id,
        has_upcoming_shift: meta.has_upcoming_shift,
        has_upcoming_turn_in: meta.has_upcoming_turn_in,
        has_needing_check_in: meta.has_needing_check_in,
        has_upcoming_checkout: meta.has_upcoming_checkout,
        loading: false,
        total: meta.total,
        from: meta.from,
        to: meta.to,
        usersIds: [],
        forceFetch: false,
      };
    case GET_USERS_FAILED:
      return { ...state, loading: false, error };
    case RESEND_INVITE_REQUEST:
      return { ...state, loading: true };
    case RESEND_INVITE_SUCCESS:
      return { ...state, loading: false };
    case RESEND_INVITE_FAILED:
      return { ...state, loading: false, error };
    case ASSIGN_LABELS_REQUEST:
      return { ...state, loading: true };
    case ASSIGN_LABELS_SUCCESS:
      return { ...state, loading: false, forceFetch: true };
    case ASSIGN_LABELS_FAILED:
      return { ...state, loading: false, error };
    case SET_SELECTED_USER:
      return {
        ...state,
        usersIds: toggleSelected(state.usersIds, userId),
        users: state.users.map((i) => (userId === i.id ? { ...i, _selected: !i._selected } : i)),
      };
    case TOGGLE_ALL_ROWS:
      return {
        ...state,
        usersIds: selectAll ? state.users.map(({ id }) => id) : [],
        users: state.users.map((i) => ({ ...i, _selected: selectAll })),
      };
    case POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS:
    case POST_SMS_CAMPAIGN_SUCCESS:
    case POST_SEND_SMS_SUCCESS:
    case GET_CHAT_MESSAGES_SUCCESS:
    case ADD_USER_WITH_CSV_SUCCESS:
      return { ...state, forceFetch: true };
    default:
      return state;
  }
};

export default usersReducer;
